import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { listingGalleryImages } from './ListingPage.shared';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, isListingPage, viewport } = props;
  const imageReviews = listing?.attributes?.publicData?.imageReviews;
  const images = listingGalleryImages(listing, imageReviews);
  const imageVariants = [
    'scaled-small',
    'scaled-medium',
    'scaled-large',
    'scaled-xlarge',
    'listing-card-2x',
    'listing-card-6x',
  ];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`, `${variantPrefix}-6x`];

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        isListingPage={isListingPage}
        viewport={viewport}
      />
    </section>
  );
};

export default SectionGallery;
